import React from "react";
import { Typography, Button, Form, Input, message, Drawer } from "antd";
import { CREATE_NOTIFICATION } from "./requests";
import { useMutation } from "@apollo/client";
import { Container } from "../../../elements";

const { Title, Text } = Typography;

type CreateNotificationProps = {
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  refetch: () => Promise<any>;
};

type FormValues = {
  title: string;
  description: string;
};

const CreateNotification: React.FC<CreateNotificationProps> = ({
  showModal,
  setShowModal,
  refetch,
}) => {
  const [form] = Form.useForm<FormValues>();

  const onClose = () => {
    setShowModal(false);
  };

  const [createNotificationMutation] = useMutation(CREATE_NOTIFICATION);

  const onFinish = async (values: FormValues) => {
    try {
      const payload = {
        variables: {
          notification: {
            title: values.title,
            description: values.description,
          },
        },
      };
      await createNotificationMutation(payload);
      await refetch();
      message.success("Se creó con éxito!");
    } catch (err) {
      console.error(err);
      message.error("Error al crear");
    } finally {
      onClose();
      form.resetFields();
    }
  };

  return (
    <Container>
      <Drawer
        open={showModal}
        onClose={onClose}
        title={<Title level={3}>Crear Notificación</Title>}
        width={"50%"}
      >
        <Form form={form} name="notification" onFinish={onFinish}>
          <div>
            <Text style={{ marginRight: 10,
              fontSize: 14 }}>
              Nombre de la Notificación <Text style={{ color: "red" }}> *</Text>
            </Text>
            <Form.Item
              name="title"
              rules={[{ required: true,
                message: "Este campo es obligatorio" }]}
            >
              <Input placeholder="Ingrese el nombre" />
            </Form.Item>
          </div>
          <div>
            <Text style={{ marginRight: 10,
              fontSize: 14 }}>
              Descripción <Text style={{ color: "red" }}> *</Text>
            </Text>
            <Form.Item
              name="description"
              rules={[{ required: true,
                message: "Este campo es obligatorio" }]}
            >
              <Input placeholder="Ingrese la descripción" />
            </Form.Item>
          </div>
          <div style={{ marginTop: 20 }}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Crear Notificación
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Drawer>
    </Container>
  );
};

export default CreateNotification;
